var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-image" },
    [
      _vm.lowStock && !_vm.outOfStock
        ? [
            _c("div", { staticClass: "low-stock-badge" }, [
              _vm._v("\n      Low Stock\n    "),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        { staticClass: "product-link", attrs: { to: _vm.path, tag: "a" } },
        [
          _c("AImage", {
            attrs: {
              img: _vm.item.image,
              preset: "wineproductteaser",
              contain: "",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }